export default (value, pad) => `${pad}${value}`.slice(-pad.length);
